import { useQuery } from '@tanstack/react-query';

import { useProfile } from 'context/profile';
import { dischargeCalendarQueryKeys, indexDischargeCalendar } from 'services/api/dischargeCalendar';
import {
  useDayViewState,
  useDischargeCalendarCurrentView,
  useDischargeCalendarFilters,
  useDischargeCalendarSearch,
  useMonthViewState,
  useWeekViewState,
} from 'stores/dischargeCalendarStore';

import { DISCHARGE_CALENDAR_VIEWS } from '../constants';

export default function useDischargeCalendarData() {
  const { profile } = useProfile();
  const currentView = useDischargeCalendarCurrentView();
  const filters = useDischargeCalendarFilters();
  const search = useDischargeCalendarSearch();

  const weekView = useWeekViewState();
  const monthView = useMonthViewState();
  const dayView = useDayViewState();

  // Get the date range based on current view
  const getDateRange = () => {
    switch (currentView) {
      case DISCHARGE_CALENDAR_VIEWS.WEEK:
        return { startDate: weekView.startDate, endDate: weekView.endDate };
      case DISCHARGE_CALENDAR_VIEWS.MONTH:
        return { startDate: monthView.startDate, endDate: monthView.endDate };
      case DISCHARGE_CALENDAR_VIEWS.DAY:
        return { startDate: dayView.startDate, endDate: dayView.endDate };
      default:
        return { startDate: weekView.startDate, endDate: weekView.endDate };
    }
  };

  const { startDate, endDate } = getDateRange();

  const queryParams = {
    startDate,
    endDate,
    filters,
    search,
  };

  return useQuery({
    queryKey: dischargeCalendarQueryKeys.index({
      clientId: profile.actingClientId,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      filters,
      search,
    }),
    queryFn: ({ signal }) => indexDischargeCalendar(queryParams, signal),
    staleTime: 30000,
  });
}
